module.exports = __webpack_public_path__ + "static/media/expression_dissatisfied.0492ab17.svg";